var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAddLecOrQuizIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/1999/xlink",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "AddLecOrQuizIcon"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27364",
    "data-name": "Rectangle 27364",
    width: 16,
    height: 16,
    transform: "translate(676 439)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_372",
    "data-name": "Mask Group 372",
    transform: "translate(-676 -439)",
    clipPath: "url(#AddLecOrQuizIcon)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svgexport-6_33_",
    "data-name": "svgexport-6 (33)",
    transform: "translate(676 439)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10597",
    "data-name": "Path 10597",
    d: "M8,0a8,8,0,1,0,8,8A8.009,8.009,0,0,0,8,0ZM8,0",
    fill: "#7e59d1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10598",
    "data-name": "Path 10598",
    d: "M11.5,8.667H8.667V11.5a.667.667,0,1,1-1.333,0V8.667H4.5a.667.667,0,0,1,0-1.333H7.333V4.5a.667.667,0,1,1,1.333,0V7.333H11.5a.667.667,0,1,1,0,1.333Zm0,0",
    fill: "#fafafa"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddLecOrQuizIcon);
export default __webpack_public_path__ + "static/media/add-lec-or-quiz-icon.3288115179e2235d723c4b5fa3712ef7.svg";
export { ForwardRef as ReactComponent };